/**
 * 企业交易明细
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton, XSelect, XDatePicker } from '@/components/xqxc_ui';
import model from '@/reducers/finance/enterprisereconciliation/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';

class Main extends React.Component {

    state = {
        orderId: '',
        accountName: '',
        subAccountName: '',
        transactionName: {},
        incomeDrawType: {},
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
    }

    componentDidMount() {
        this.props.getTransactionNameList({ enumName: 'MisTransTypeEnum' });
        this.props.getIncomeDrawTypeList({ enumName: 'BizLoanType' });
    }

    // 查询
    _searchHandle = (useCache) => {
        const { orderId, accountName, subAccountName, transactionName, incomeDrawType, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            orderId,
            companyName: accountName,
            transAccNo: subAccountName,
            transType: transactionName.code,
            loanType: incomeDrawType.code,
            startDate: startTime,
            endDate: endTime,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getReconciliationDetailList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 重置
    _resetHandle = () => {
        this.setState({ orderId: '', accountName: '', subAccountName: '', transactionName: {}, incomeDrawType: {}, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    render() {
        const { orderId, accountName, subAccountName, transactionName, incomeDrawType, startTime, endTime } = this.state;
        let { curTabID, transactionDetailList, transactionNameList, incomeDrawTypeList } = this.props;

        return (
            <KeepAlive id={curTabID} render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 150 }}
                                label='订单号'
                                placeholder='请输入'
                                value={orderId}
                                bindThis={this}
                                bindName='orderId'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 150 }}
                                label='账号名称'
                                placeholder='请输入'
                                value={accountName}
                                bindThis={this}
                                bindName='accountName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 150 }}
                                label='子账户名称'
                                placeholder='请输入'
                                value={subAccountName}
                                bindThis={this}
                                bindName='subAccountName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: 150 }}
                                label='交易名称'
                                placeholder='请选择'
                                renderData={transactionNameList}
                                dataIndex='value'
                                keyIndex='code'
                                value={transactionName.value}
                                bindThis={this}
                                bindName='transactionName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: 100 }}
                                label='收支类型'
                                placeholder='请选择'
                                renderData={incomeDrawTypeList}
                                dataIndex='value'
                                keyIndex='code'
                                value={incomeDrawType.value}
                                bindThis={this}
                                bindName='incomeDrawType'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='交易日期'
                                datePickerStyle={{ width: 130 }}
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                showTime={false}
                                defaultTime='00:00:00'
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                datePickerStyle={{ width: 130 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                showTime={false}
                                defaultTime='23:59:59'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '10px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableList renderData={transactionDetailList} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,

    getReconciliationDetailList: PropTypes.func,
    transactionDetailList: PropTypes.object,

    getTransactionNameList: PropTypes.func,
    transactionNameList: PropTypes.array,

    getIncomeDrawTypeList: PropTypes.func,
    incomeDrawTypeList: PropTypes.array,
};
const mapStateToProps = (state) => ({
    incomeDrawTypeList: state.enterprisereconciliation.incomeDrawTypeList,
    transactionNameList: state.enterprisereconciliation.transactionNameList,
    transactionDetailList: state.enterprisereconciliation.transactionDetailList,
});

export default connect(mapStateToProps, { ...model.actions })(Main);